export default "__VITE_ASSET__BWBKFQXF__"